module.exports = __webpack_public_path__ + "img/2.48121cc9.png";